<template>
    <Layout>
    
    <div class="home-page-80-width mt-5">
        <div class="row align-items-center pb-3 mb-4 border-bottom">
            <!-- Back link -->
            <div class="col-6 col-md-3 text-start">
                <a class="text-decoration-none text-dark d-inline-flex align-items-center" href="/panier">
                <img
                    style="padding-bottom: 2px;"
                    height="22"
                    :src="require('@/assets/icons/arrow-left.svg')"
                    alt="Retour au panier"
                />
                <span class="ms-2 font-size-16">Panier</span>
                </a>
            </div>
    
            <!-- Title centered -->
            <div class="col-12 col-md-6 text-center">
                <h1 class="fw-semibold text-dark mb-0" style="font-size: 2.5rem;">Paiement</h1>
            </div>
    
            <!-- Empty space on right for alignment -->
            <div class="d-none d-md-block col-md-3"></div>
        </div>
      
         
      
        <div class="row">
            <div class="col-md-4 order-md-2">
                <div class=" mb-4 mt-0 position-sticky " style="top: 6rem;">
                    <div class="card-header py-3 bg-white">
                        <h2 class="mb-0 fw-semibold  text-dark">Commande</h2>
                    </div>
                    <div class="card-body">
                        <!-- Order Items -->
                        <div class="mb-3">
                            <div v-for="(item) in orderItems" :key="item.variantId" class="d-flex d-md-block d-lg-flex justify-content-between justify-content-md-start justify-content-lg-between mb-2">
                                <div class="text-left mt-2">
                                    <h6 class="my-0  text-dark font-weight-bold">{{ item.variants[0].cartItemQuantity  }} x {{item.title }}</h6>
                                    <small class="text-muted font-size-14">{{ item.variants[0].title}}</small>
                                    <div><span class="badge badge-light font-weight-bold">{{ item.paperTypeLabel }}</span></div>
                                </div>
                                <span class="text-right text-dark mt-2 font-weight-bold">{{item.variants[0].cartItemSubTotal }}</span>
                            </div>
                        </div>
        
                      
                        <hr>
                        <!-- Subtotal -->
                        <div class="d-flex justify-content-between mb-3 text-dark">
                            <span>Sous Total</span>
                            <span>{{  cart.lines.cartSubTotal }}</span>
                        </div>
            
                        <!-- Shipping -->
                        <div class=" d-flex justify-content-between mb-3  text-dark">
                            <span>Mode de Livraison</span>
                            <span> {{ cart.deliveryMode.name }}</span>
                        </div>
                        
                        
                        <div class="d-flex justify-content-between mb-3  text-dark">
                            <span>Frais de Livraison</span>
                            <span>{{ cart.lines.cartSubTotalAsFloat >= cart.deliveryMode.deliveryFreeThreshold  ? 'Gratuit': cart.lines.cartDelievryCost }}</span>
                        </div>
                        <hr>
                        <!-- Total -->
                        <div class="d-flex justify-content-between mb-3  text-dark">
                            <span class="fw-semibold">Total</span>
                            <strong>{{  cart.lines.cartTotal  }}</strong>
                        </div>  
                        <hr>
                          <!-- Discount (conditionally rendered) -->
                        <div v-if="cart.giftCardCode"  class="d-flex justify-content-between mb-3 text-dark">
                            <span class="fw-semibold">{{ $t('giftCard.payment') }}</span>
                            <strong>{{ cart.lines.giftCardAmount }}</strong>
                        </div>
                        <div v-if="cart.lines.finalAmountToPay"  class="d-flex justify-content-between mb-3 text-dark">
                            <span class="fw-semibold">Net à payer</span>
                            <strong>{{ cart.lines.finalAmountToPay }}</strong>
                        </div>

                        <PaymentComponent class="mt-4 mb-4" 
                          :isOnlinePaymentEnabled="cart.isBankCardAccepted"
                          :defaultPaymentMode="1"
                        @paymentMode="handelPaymentMode"/>

                        <div v-if="paymentModeId == 1">

                            <p class="mb-3 mt-4 text-center">Vous serez redirigé vers notre passerelle de paiement sécurisée pour finaliser votre achat</p>
                                
                            <p class="text-dark text-center font-size-14">
                                <img
                                    style="padding-bottom: 2px;"
                                    height="25"
                                    :src="require('@/assets/icons/secure.svg')"
                                    alt="Retour au panier"
                                />
                                Toutes les transactions sont sécurisées et cryptées
                            </p>

                        </div>

                        <div v-else>
                            <p class="mb-3 mt-4 text-center">
                                Notre service client vous contactera dans <strong>24 heures</strong> pour confirmer la commande.
                            </p>

                            <p class="text-dark text-center font-size-14">
                                <img
                                style="padding-bottom: 2px;"
                                height="25"
                                :src="require('@/assets/icons/call-center.svg')"
                                alt="Service client"
                                />
                                Merci de rester joignable pour confirmer votre commande.
                            </p>
                        </div>



                        <button 
                            type="button"
                            class="btn btn-primary font-size-18 btn-lg w-100 text-uppercase"  
                            style="  letter-spacing: 2px;font-weight: 500;"
                            @click="handleSubmit"
                            >
                            <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            {{ isSubmitting ? 'Validation...' :  paymentModeId == 1 ? 'Valider et Payer' : 'Valider' }}
                        </button>
                    </div>
              </div>
            </div>
            <div class="col-md-8 order-md-1" v-if="userFullName">
            <div class="card shadow-sm border-0 rounded p-4 bg-light">

                <h5 class="text-primary font-weight-bold mb-4 border-bottom pb-2">
                <i class="fa fa-user-circle mr-2"></i> Informations du client
                </h5>

                <div class="row mb-4">
                <div class="col-sm-6 mb-3">
                    <div class="text-muted small">Nom</div>
                    <div class="font-weight-bold">{{ form && form.customerFullName }}</div>
                </div>
                <div class="col-sm-6 mb-3">
                    <div class="text-muted small">Téléphone</div>
                    <div class="font-weight-bold">{{ form && form.customerPhone }}</div>
                </div>
                <div class="col-sm-6 mb-3">
                    <div class="text-muted small">Email</div>
                    <div class="font-weight-bold">{{ form && form.customerEmail }}</div>
                </div>
                <div class="col-sm-6 mb-3">
                    <div class="text-muted small">Société</div>
                    <div class="font-weight-bold">{{ form && form.companyName }}</div>
                </div>
                <div class="col-sm-6 mb-3">
                    <div class="text-muted small">Pays</div>
                    <div class="font-weight-bold">{{ form && form.country ? form.country.name : '' }}</div>
                </div>
                <div class="col-sm-6 mb-3">
                    <div class="text-muted small">Ville</div>
                    <div class="font-weight-bold">
                    {{ form && form.state ? form.state.name : '' }} ({{ form && form.postalCode }})
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <div class="text-muted small">Adresse</div>
                    <div class="font-weight-bold">{{ form && form.address }}</div>
                </div>
                <div class="col-12 mb-3">
                    <div class="text-muted small">Matricule fiscal</div>
                    <div class="font-weight-bold">{{ form && form.fiscalNumber }}</div>
                </div>
                </div>

                <div class=" col-12  mt-3">
                    <div class="form-group">
                        <label for="graphisteMessage">Contacter le graphiste (vous pouvez laisser une note au graphiste si vous avez besoin d'ajuster légérement votre design)</label>
                        <textarea id="graphisteMessage" name="graphisteMessage" 
                        class="form-control" rows="3" 
                        v-model="form.graphisteMessage"></textarea>
                    </div>
                </div>
                <div class=" col-12">
                    <div class="form-group">
                        <label for="feedback">Vos avis et vos suggestions</label>
                        <textarea id="feedback" name="feedback" 
                        class="form-control" rows="3" 
                        v-model="form.feedback"></textarea>
                    </div>
                </div>

            </div>
            </div>


            <div v-else class="col-md-8 order-md-1 pr-md-3">
                <form>
                      
                    <!-- Info Clients -->
                    <div class="card mb-4 mt-0  box-hovered">
                        <div class="card-header py-3 bg-white">
                            <h2 class="mb-0 fw-semibold  text-dark">Informations Client</h2>
                        </div>
                        <div class="card-body mb-3">
                            <div class="row">
                                <div class="col-12 text-left col-md-6 pr-md-2  text-dark">
                                    <label for="fullName" class="form-label">Nom & Prénom</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        id="fullName" 
                                        v-model="form.customerFullName"
                                        :class="{'is-invalid': errors.customerFullName}"
                                        required
                                    >
                                    <div class="invalid-feedback" v-if="errors.customerFullName">
                                        {{ errors.customerFullName }}
                                    </div>
                                </div>
                                <div class="col-12 text-left col-md-6 mt-3 mt-md-0 text-dark">
                                    <label for="phone" class="form-label">Numéro de téléphone</label>
                                    <input 
                                        type="text" 
                                        class="form-control" 
                                        id="phone" 
                                        v-model="form.customerPhone"
                                        :class="{'is-invalid': errors.customerPhone}"
                                        required
                                    >
                                    <div class="invalid-feedback" v-if="errors.customerPhone">
                                        {{ errors.customerPhone }}
                                    </div>
                                </div>
                                <div class="col-12 text-left mt-3  text-dark">
                                    <label for="email" class="form-label">Email</label>
                                    <input 
                                        type="email" 
                                        class="form-control" 
                                        id="email" 
                                        v-model="form.customerEmail"
                                        :class="{'is-invalid': errors.customerEmail}"
                                        required
                                        >
                                    <div class="invalid-feedback" v-if="errors.customerEmail">
                                            {{ errors.customerEmail }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- Company -->
                    <div class="card mb-4 mt-0  box-hovered">
                        <div class="card-header py-3 bg-white">
                            <h2 class="mb-0 fw-semibold  text-dark">Entreprise</h2>
                        </div>
                        <div class="card-body">
             
                            <div class="text-dark">
                                <div class="row">
                                    <div class="col-md-6 pr-md-2">
                                        <div class="form-group">
                                            <label for="companyName">Nom de l'entreprise</label>
                                            <input type="text" id="companyName"
                                                name="companyName" class="form-control" required
                                                v-model="form.companyName"
                                                :class="{'is-invalid': errors.companyName}">
                                            <div class="invalid-feedback" v-if="errors.companyName">
                                                {{ errors.companyName }}
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="col-md-6 mt-2 mt-md-0">
                                        <div class="form-group">
                                            <label for="fiscalNumber">Matricule fiscale</label>
                                            <input type="text" id="fiscalNumber" name="fiscalNumber" class="form-control" required
                                                v-model="form.fiscalNumber"
                                                :class="{'is-invalid': errors.fiscalNumber}">
                                            <div class="invalid-feedback" v-if="errors.fiscalNumber">
                                                {{ errors.fiscalNumber }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6 pr-md-2">
                                        <div class="form-group">
                                            <label for="companyName">Enseigne</label>
                                            <input type="text" id="companyName"
                                                name="companyName" class="form-control" required
                                                v-model="form.businessName"
                                                :class="{'is-invalid': errors.businessName}">
                                            <div class="invalid-feedback" v-if="errors.businessName">
                                                {{ errors.businessName }}
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class=" col-6  ">
                                        <div class="form-group">
                                            <label for="fiscalDocument">Patente fiscale (image)</label>
                                            <div class="input-group">
                                                <input 
                                                type="text"
                                                :class="['form-control', { 'is-invalid': errors.fiscalDocument }]"
                                                :value="form.fiscalDocumentName"
                                                placeholder="Aucun fichier sélectionné"
                                                disabled
                                                />
                                                <div class="input-group-append">
                                                <label class="btn btn-outline-primary mb-0">
                                                    {{ form.fiscalDocumentName ? 'Modifier' : 'Ajouter' }}
                                                    <input
                                                    type="file"
                                                    id="fiscalDocument"
                                                    name="fiscalDocument"
                                                    class="d-none"
                                                    accept=".jpeg,.jpg,.png"
                                                    @change="handleFileUpload"
                                                    />
                                                </label>
                                                </div>
                                            </div>
    
                                            <div class="invalid-feedback d-block" v-if="errors.fiscalDocument">
                                                {{ errors.fiscalDocument }}
                                            </div>
                                        </div>
    
                                    </div>

        
                                    <div class=" col-md-12   mt-2 mt-md-0">
                                        <label for="postalCode" class="form-label">Référent commercial APS</label>
                                        <input 
                                            class="form-control" 
                                            id="postalCode" 
                                            v-model="form.salesRepresentative"
                                            :class="{'is-invalid': errors.salesRepresentative}"
                                            required
                                        >
                                        <div class="invalid-feedback" v-if="errors.salesRepresentative">
                                            {{ errors.salesRepresentative }}
                                        </div>
                                    </div>

                                </div>
                            </div>
                               
                        </div>
                    </div>

                     <!-- ADDRESS -->
                    <div class="card mb-4 mt-0  box-hovered">
                        <div class="card-header py-3 bg-white">
                            <h2 class="mb-0 fw-semibold  text-dark">Adresse</h2>
                        </div>
                        <div class="card-body">
                            <div class="text-dark">
                                <div class="row">
                                    <div class=" col-12 mb-3">
                                        <label for="address" class="form-label">Addresse</label>
                                        <input 
                                        type="text" 
                                        class="form-control" 
                                        id="address" 
                                        v-model="form.address"
                                        :class="{'is-invalid': errors.address}"
                                        required
                                        >
                                        <div class="invalid-feedback" v-if="errors.address">
                                        {{ errors.address }}
                                        </div>
                                    </div>
            
                                    <div class="col-md-6  pr-md-2">                                
                                        <label for="state" class="form-label">Ville</label>
                                        <v-select  class="font-size-18" variant="underlined" 
                                            :options="citiesList"  label="name" 
                                            v-model="form.state" required                             
                                            id="state" 
                                            :class="{'is-invalid': errors.state}"
                                            >
                                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                        </v-select>
                                    
                                        <div class="invalid-feedback" v-if="errors.state">
                                            {{ errors.state }}
                                        </div>
                                    </div>
                                    <div class=" col-md-6   mt-2 mt-md-0">
                                        <label for="postalCode" class="form-label">Code postal</label>
                                        <input 
                                            type="number" 
                                            class="form-control" 
                                            id="postalCode" 
                                            v-model="form.postalCode"
                                            :class="{'is-invalid': errors.postalCode}"
                                            required
                                        >
                                        <div class="invalid-feedback" v-if="errors.postalCode">
                                            {{ errors.postalCode }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Messages -->
                    <div class="card mb-4 mt-0  box-hovered">
                        <div class="card-header py-3 bg-white">
                            <h2 class="mb-0 fw-semibold  text-dark">Observations & Ajustements</h2>
                        </div>
                        <div class="card-body">
                           
                            <div class="text-dark">
                                <div class="row">
                                    <div class=" col-12">
                                        <div class="form-group">
                                            <label for="graphisteMessage">
                                                Contacter le graphiste 
                                                <small class="text-muted d-block">
                                                (vous pouvez laisser une note au graphiste si vous avez besoin d'ajuster légèrement votre design)
                                                </small>
                                            </label>

                                            <textarea id="graphisteMessage"
                                                        name="graphisteMessage"
                                                        class="form-control"
                                                        rows="3"
                                                        v-model="form.graphisteMessage"
                                                        maxlength="512">
                                            </textarea>

                                            <small class="text-muted d-block text-right">
                                                {{ form.graphisteMessage.length }} / 512
                                            </small>
                                        </div>

                                    </div>
                                    <div class=" col-12">
                                        <div class="form-group">
                                            <label for="feedback">
                                                Vos avis et vos suggestions
                                            </label>

                                            <textarea id="feedback"
                                                        name="feedback"
                                                        class="form-control"
                                                        rows="3"
                                                        v-model="form.feedback"
                                                        maxlength="512">
                                            </textarea>

                                            <small class="text-muted d-block text-right"
                                                    :class="{ 'text-danger': form.feedback.length >= 512 }">
                                                {{ form.feedback.length }} / 512
                                            </small>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            


                        </div>
                    </div>
              </form>
            </div>
          </div>
      
         
    </div>

    <b-modal
        v-model="showError"
        hide-footer
        centered
        size="lg"
        header-class="border-0 pb-0 m-2"
        body-class="pt-0"
        content-class="border-0 rounded-lg"
        modal-class="error-payment-modal"
        >
        <template #modal-header>
            <div class="d-flex w-100 align-items-center">
                <h5 class="modal-title font-weight-bold mb-0 text-dark">Erreur de paiement</h5>
            </div>
        </template>
        <div class="text-center py-3">
            <div class="mb-3 mx-auto bg-danger-light rounded-circle p-3 d-inline-block">
                <img :src="require('@/assets/icons/alert-circle.svg')"
                      width="70" height="70" alt="Success" />
            </div>
            <div class="error-message mb-4">
                <strong class="text-danger d-block mb-3 font-size-18">Nous sommes désolés, mais votre paiement par carte a échoué.</strong>
                <p class="text-dark mb-0">Veuillez vérifier les informations de votre carte et réessayer.</p>
            </div>
            <div class="mt-2">
                <b-button variant="danger" class="px-4 py-2" @click="showError = false">
                    <img :src="require('@/assets/icons/check.svg')"
                      width="20" height="20" alt="Success" />
                    Compris
                </b-button>
            </div>
        </div>
    </b-modal>
    </Layout>
</template>
      
<script>
    import Layout from "../../layouts/main.vue";
    import OrdersApi from "@/services/orders-api";
    import CountriesApi from "@/services/countries-api";
    import CustomerApi from "@/services/customers-api";
    import PaymentComponent from "@/components/PaymentComponent.vue";

    export default {
        name: 'Checkout',
        components: { Layout, PaymentComponent },
        props: {
            state:String
        },
        data() {
            return {
                citiesList:[],
                subtotal: 25.00,
                discount: 0,
                promoCode: "",
                promoError: null,
                promoSuccess: null,
                // Form data
                form: {
                    customerFullName: "",
                    customerEmail: "",
                    customerPhone: "",
                    address: "",
                    state: "",
                    fiscalNumber:"",
                    companyName:"",
                    feedback:"",
                    graphisteMessage:"",
                    fiscalDocument:null,
                    fiscalDocumentName: '',
                    country:null,
                    postalCode:"",
                },
                errors: {},
    
                isSubmitting: false,
                
                orderNumber: "",
                confirmationEmail: "",
                showConfirmation: false,
                showError: null,
                paymentModeId: 1,
                
            };
        },
        computed: {
            cart() {
                return this.$store.state.cart;
            },
            orderItems() {
                return this.cart?.lines?.list || [];
            },

            userFullName() {
                return this.$cookies.isKey('userFullName') ? this.$cookies.get('userFullName') : '';      
            },
        },
        created() {
          this.$store.dispatch('fetchCart');
        },
        
        mounted() {
            if(this.state && this.state =='false' ){
                this.showError = true
            }
            this.getTunisiaCities();
            this.getCustomerInfo()
        },
    
        beforeDestroy() {
            const mainContent = document.querySelector('.main-content');
            if (mainContent && mainContent.dataset.originalStyle !== undefined) {
            mainContent.setAttribute('style', mainContent.dataset.originalStyle);
            }
        },
        methods: {

            handelPaymentMode(paymentModeId){
                this.paymentModeId = paymentModeId
            },
            
            getCustomerInfo(){
                if(!this.userFullName){
                    return;
                }
                CustomerApi.getCustomerInfo().then(
                    result => {
                    this.mapCustomerInfoToForm(result)
                    }
                )
            },

            mapCustomerInfoToForm(result) {
                this.form = {
                    customerFullName: result.name || "",
                    customerEmail: result.mail || "",
                    customerPhone: result.phone || "",
                    address: result.deliveryAddress || "",
                    state: result.city || "",
                    fiscalNumber: result.taxRefNumber || "",
                    companyName: result.companyName || "",
                    feedback: this.form.feedback,
                    graphisteMessage: this.form.graphisteMessage,
                    fiscalDocument: result.fiscalDocument || null,
                    fiscalDocumentName: result.fiscalDocumentName || "",
                    postalCode: result.postalCode || "",
                    country: result.country || null,
                    salesRepresentative: result.salesRepresentative || null,
                    businessName: result.businessName || null,
                };
            },

            handleFileUpload(event) {
                const file = event.target.files[0];
                if (file) {
                    if (!file.type.startsWith('image/')) {
                        this.errors.fiscalDocument = "Le fichier doit être une image (.jpg, .png, .jpeg).";
                        this.form.fiscalDocument = null;
                        this.form.fiscalDocumentName = file.name;
                        return;
                    }
                    if (!this.isFileSizeAccepted(file)) {
                        this.form.fiscalDocument = null;
                        this.form.fiscalDocumentName = file.name;
                        return;
                    }else{
                        this.form.fiscalDocument = file;
                        this.form.fiscalDocumentName = file.name;
                    }
                }
            },
            isFileSizeAccepted(file){
                this.errors.fiscalDocument="";
                const maxSizeMB = 2;
                if(file == null ){
                    this.showErrors();
                    return false;
                }
                const fileSizeMB = file.size / (1024 * 1024);

                if (fileSizeMB > maxSizeMB) {
                    this.errors.fiscalDocument =`La taille du fichier dépasse ${maxSizeMB} Mo. Veuillez télécharger un fichier plus petit.`;
                    this.showErrors();
                    return false;
                }else{
                    return true;
                }
            },
            getTunisiaCities(){
                CountriesApi.getTunisiaCities().then(
                result => {
                    this.citiesList = result
                })
            },
            backToCart() {
                this.$router.push('/panier');
            },
            
           
            
            
            // Form validation
            validateForm() {
                this.errors = {};
                let isValid = true;
                // Basic validation
                if (!this.form.customerFullName || this.form.customerFullName.trim() === "") {
                    this.errors.customerFullName = "le Nom & Prénom est requis";
                    isValid = false;
                }
                if (!this.form.customerEmail || this.form.customerEmail.trim() === "") {
                    this.errors.customerEmail = "Adresse email est requis";
                    isValid = false;
                } else if (!/\S+@\S+\.\S+/.test(this.form.customerEmail)) {
                    this.errors.customerEmail = "Mettez une adresse email valide";
                    isValid = false;
                }
                if (!this.form.customerPhone || this.form.customerPhone.trim() === "") {
                    this.errors.customerPhone = "Numéro de téléphone est requis";
                    isValid = false;
                }
                if (!this.form.address|| this.form.address.trim() === "") {
                    this.errors.address = "Addresse est requis";
                    isValid = false;
                }
                // if (!this.form.companyName || this.form.companyName.trim() === "") {
                //     this.errors.companyName = "Nom de l'entreprise est requis";
                //     isValid = false;
                // }
                // if (!this.userFullName && (this.form.fiscalDocument == null  || !this.form.fiscalDocumentName || this.form.fiscalDocumentName.trim() == "")) {
                //     this.errors.fiscalDocument = "Patente fiscale est requis";
                //     isValid = false;
                // }
                if (!this.userFullName == null && this.form.fiscalDocument !== null) {
                    if(!this.isFileSizeAccepted(this.form.fiscalDocument )){
                        this.form.fiscalDocument = null;
                        isValid = false;
                    }
                    
                }
                // if (!this.form.fiscalNumber || this.form.fiscalNumber.trim() === "") {
                //     this.errors.fiscalNumber = "Code fiscal est requis";
                //     isValid = false;
                // }
                if (!this.form.postalCode || this.form.postalCode.trim() === "") {
                    this.errors.postalCode = "Code postal est requis";
                    isValid = false;
                }
                if (!this.form.state || !this.form.state.id) {
                    this.errors.state = "Ville est requis";
                    isValid = false;
                }
                return isValid;
            },
            showErrors(){
                 this.$nextTick(() => {
                        const firstError = document.querySelector('.is-invalid');
                        if (firstError) {
                            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            firstError.focus();
                        }
                    });
            },
            handleSubmit() {
                if (!this.validateForm()) {
                   this.showErrors();
                    return;
                }
                const formData = new FormData();
                if (this.cart?.cartId != null) {
                formData.append('cartId', this.cart.cartId);
                }
                if (this.form?.customerFullName != null) {
                formData.append('guestName', this.form.customerFullName);
                }
                if (this.form?.customerEmail != null) {
                formData.append('guestMail', this.form.customerEmail);
                }
                if (this.form?.customerPhone != null) {
                formData.append('guestPhone', this.form.customerPhone);
                }
                if (this.form?.address != null) {
                formData.append('guestDeliveryAddress', this.form.address);
                }
                if (this.form?.postalCode != null) {
                formData.append('guestPostalCode', this.form.postalCode);
                }
                if (this.form?.state?.id != null) {
                formData.append('guestCityId', this.form.state.id);
                }
                if (this.form?.companyName != null) {
                formData.append('companyName', this.form.companyName);
                }
                if (this.form?.fiscalNumber != null) {
                formData.append('fiscalNumber', this.form.fiscalNumber);
                }
                if (!this.userFullName && this.form?.fiscalDocument != null) {
                formData.append('fiscalDocument', this.form.fiscalDocument);
                }
                if (this.form?.feedback != null) {
                formData.append('feedback', this.form.feedback);
                }
                if (this.form?.graphisteMessage != null) {
                formData.append('graphisteMessage', this.form.graphisteMessage);
                }
                if (this.paymentModeId != null) {
                formData.append('paymentMethode', this.paymentModeId);
                }
                if (this.form?.salesRepresentative != null) {
                formData.append('salesRepresentative', this.form.salesRepresentative);
                }
                if (this.form?.businessName != null) {
                formData.append('businessName', this.form.businessName);
                }

                this.isSubmitting = true;
                OrdersApi.cartToOrder(formData)
                    .then(result => { 
                        if(result && result.paymentUrl){
                            window.location.href = result.paymentUrl;
                        } else {
                            //display order summary page and clean cartId from store
                            window.location.href = `/commande/card/validee?order_s_ref=`+result.order.specialRef;
                        }
                    })
                    .catch(error => {this.paymentRequestError = error;})
                    .finally(
                        this.isSubmitting = false
                    )
            },
            
            // Reset form after successful submission
            resetForm() {
                this.form = {
                    customerFullName: "",
                    customerEmail: "",
                    customerPhone: "",
                    address: "",
                    state: "",
                    fiscalDocumentName: "",
                    fiscalDocument: null,
                    postalCode:"",
                    companyName:"",
                    fiscalNumber:"",
                    feedback:"",
                    graphisteMessage:"",
                };
                
                this.promoCode = "";
                this.discount = 0;
                this.promoError = null;
                this.promoSuccess = null;
                this.errors = {};
            }
        }
      };
</script>
    
<style scoped>
    
    .card {
        border-radius: 0.5rem;
        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    }
    
    .card-header {
        border-top-left-radius: 0.5rem;
        border-top-right-radius: 0.5rem;
    }
    
    .box-with-title {
        border: 1px solid #cbcbcb;
        width: 100%;
        margin-top: 20px;
        box-sizing: border-box;
        position: relative;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    
    }
    .box-hovered{
        border: 1px solid #cbcbcb;
        width: 100%;
        margin-top: 20px;
        box-sizing: border-box;
        position: relative;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
         border-radius:5px;
    }
    .form-control.is-invalid,
    .input-group.is-invalid .form-control,
    .v-select.is-invalid .vs__dropdown-toggle {
      border:1px solid #ced4da;
      background-color: transparent;
    }
    .form-control.is-invalid:focus {
      box-shadow: none;
    }
    .error-container {
      border: 1px solid #ced4da;
      background-color: transparent;
    }

</style>